import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-payment-discount-dialog',
  templateUrl: './payment-discount-dialog.component.html',
  styleUrls: ['./payment-discount-dialog.component.scss'],
})
export class PaymentDiscountDialogComponent {
  cashDiscount: number = 0;
  discountRemarks;
  discountPercentage: number = 0;
  nettAmount: number = 0;
  
  // Getter for display purposes - shows 2 decimal places
  get displayCashDiscount(): string {
    return this.cashDiscount.toFixed(2);
  }
  percentagePresets = ['5', '10', '15', '20', '50', '100', 'custom'];
  showPercentageDiscountInput: boolean;
  selectedPercentageDiscountIndex: number;
  cashDiscountError = false;
  discountRemarksError = false;
  isRemarkRequire = false;

  constructor(
    private dialogRef: MatDialogRef<PaymentDiscountDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any
  ) {
    this.nettAmount = data.totalAmount;
    this.discountRemarks = data.discountRemarks;
    this.isRemarkRequire = data.isRemarkRequire;

  }

  submit() {
    if(this.cashDiscount <= 0 || !this.checkDiscountRemark()){
      if(this.cashDiscount <= 0){
        this.cashDiscountError = true;
      }
      if(!this.checkDiscountRemark()){
        this.discountRemarksError = true;
      }
    } else {
      this.dialogRef.close({
        cashDiscount: this.cashDiscount,
        discountPercentage: this.discountPercentage,
        discountRemarks: this.discountRemarks
      });
    }
  }

  calculate(type: 'cash' | 'percentage') {
    switch (type) {
      case 'cash':
        this.calculateDiscountPercentage();
        break;
      case 'percentage':
        this.calculateCashDiscount();
        break;
    }
  }

  calculateDiscountPercentage() {
    if (this.nettAmount <= 0 || this.cashDiscount <= 0 || this.cashDiscount > this.nettAmount) {
      this.discountPercentage = 0;
    }
    this.discountPercentage = +((this.cashDiscount / this.nettAmount) * 100).toFixed(2);
  }

  calculateCashDiscount() {
    if (this.nettAmount <= 0 || this.discountPercentage < 0 || this.discountPercentage > 100) {
      this.cashDiscount = 0;
    }

    // Calculate with 4 decimal precision, then round to 2 for display
    const preciseDiscount = (this.discountPercentage / 100) * this.nettAmount;
    this.cashDiscount = +preciseDiscount.toFixed(4);
  }

  selectPercentageDiscount(item: string, itemIndex: number) {
    this.selectedPercentageDiscountIndex = itemIndex;
    this.showPercentageDiscountInput = false;
    if (item === 'custom') {
      this.showPercentageDiscountInput = true;
    } else {
      this.discountPercentage = +item;
      this.calculate('percentage');
    }
  }

  checkDiscountRemark() {
    if(this.isRemarkRequire){
      if(!this.discountRemarks){
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  }
}
